import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useMemo } from 'react';
import { DescriptionBlock } from '../job-description-block';
import { JobContract } from '../job-contract';
import { JobShifts } from '../job-shifts';
import { MapComponent } from '../job-location-map';
import { Title, Wrapper, ListTertiary, Paragraph, ImageCarousel } from '../../design-system';
import { usePerformanceBlockData, useSkillsBlockData } from './hooks';
import { SkillsPreviewBlock } from './skills-preview-block';
import { JobInfoCardPreview } from './job-info-card-preview';
/**
 * JobPositionPreview - Componente per mostrare l'anteprima di una posizione lavorativa
 * Utilizzato nell'employer-app per mostrare come i candidati vedranno la job position
 *
 * @param jobPosition - I dati della job position da visualizzare
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var JobPositionPreview = function JobPositionPreview(_ref) {
  var jobPosition = _ref.jobPosition;
  if (!jobPosition) return null;
  return /*#__PURE__*/_jsxs(PageContentWrapper, {
    children: [/*#__PURE__*/_jsx(MobileJobInfoCard, {
      children: /*#__PURE__*/_jsx(JobInfoCardPreview, {
        jobPosition: jobPosition
      })
    }), /*#__PURE__*/_jsx(DesktopJobInfoCard, {
      children: /*#__PURE__*/_jsx(JobInfoCardPreview, {
        jobPosition: jobPosition
      })
    }), /*#__PURE__*/_jsxs(MainContentColumn, {
      children: [/*#__PURE__*/_jsx(JobDescriptionPreview, {
        jobPosition: jobPosition
      }), /*#__PURE__*/_jsx(ContractPreview, {
        jobPosition: jobPosition
      }), /*#__PURE__*/_jsx(PerformancePreview, {
        jobPosition: jobPosition
      }), /*#__PURE__*/_jsx(SkillsPreview, {
        jobPosition: jobPosition
      }), /*#__PURE__*/_jsx(ShiftsPreview, {
        jobPosition: jobPosition
      }), /*#__PURE__*/_jsx(LocationPreview, {
        jobPosition: jobPosition
      })]
    })]
  });
}; // Descrizione del lavoro

var JobDescriptionPreview = function JobDescriptionPreview(_ref2) {
  var jobPosition = _ref2.jobPosition;
  if (!(jobPosition !== null && jobPosition !== void 0 && jobPosition.job_description)) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DescriptionBlock, {
      subTitle: jobPosition.job_title,
      jobContractDesc: jobPosition.job_description
    }), /*#__PURE__*/_jsx(Divider, {})]
  });
}; // Contratto


var ContractPreview = function ContractPreview(_ref3) {
  var jobPosition = _ref3.jobPosition;
  var contractContent = jobPosition === null || jobPosition === void 0 ? void 0 : jobPosition.job_contract_description;
  var jobBenefitsList = useMemo(function () {
    var _jobPosition$benefits;

    return jobPosition === null || jobPosition === void 0 ? void 0 : (_jobPosition$benefits = jobPosition.benefits) === null || _jobPosition$benefits === void 0 ? void 0 : _jobPosition$benefits.map(function (_ref4) {
      var benefit_var = _ref4.benefit_var;
      return {
        label: benefit_var.label,
        icon: benefit_var.icon,
        key: benefit_var.key
      };
    });
  }, [jobPosition === null || jobPosition === void 0 ? void 0 : jobPosition.benefits]);
  if (!(contractContent !== null && contractContent !== void 0 && contractContent.length)) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(JobContract, {
      contractContent: contractContent,
      jobBenefits: jobBenefitsList
    }), /*#__PURE__*/_jsx(Divider, {})]
  });
}; // Performance/Valutazioni


var PerformancePreview = function PerformancePreview(_ref5) {
  var jobPosition = _ref5.jobPosition;
  var jobPerformanceItemList = usePerformanceBlockData(jobPosition);
  if (!jobPerformanceItemList.length) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Wrapper, {
      children: [/*#__PURE__*/_jsx(Title, {
        icon: "HandThumbUpIcon",
        content: "I nostri consigli",
        variant: "h4-large",
        fontWeight: "semibold",
        textColor: "black"
      }), /*#__PURE__*/_jsx(ListTertiary, {
        jobPerformanceItemList: jobPerformanceItemList
      })]
    }), /*#__PURE__*/_jsx(Divider, {})]
  });
}; // Skills


var SkillsPreview = function SkillsPreview(_ref6) {
  var jobPosition = _ref6.jobPosition;
  var skillsData = useSkillsBlockData(jobPosition);
  if (skillsData.isEmptyData) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SkillsPreviewBlock, _objectSpread({}, skillsData)), /*#__PURE__*/_jsx(Divider, {})]
  });
}; // Turni


var ShiftsPreview = function ShiftsPreview(_ref7) {
  var _jobPosition$job_type2, _jobPosition$days_req2, _jobPosition$shifts2;

  var jobPosition = _ref7.jobPosition;
  var jobShiftsArgs = useMemo(function () {
    var _jobPosition$job_type;

    return {
      jobType: (jobPosition === null || jobPosition === void 0 ? void 0 : (_jobPosition$job_type = jobPosition.job_type_var) === null || _jobPosition$job_type === void 0 ? void 0 : _jobPosition$job_type.label) || '',
      daysRequiredPerWeek: jobPosition === null || jobPosition === void 0 ? void 0 : jobPosition.days_required_per_week,
      daysRequiredPerWeekNumber: jobPosition === null || jobPosition === void 0 ? void 0 : jobPosition.days_required_per_week_number,
      shifts: jobPosition === null || jobPosition === void 0 ? void 0 : jobPosition.shifts,
      shiftNotes: (jobPosition === null || jobPosition === void 0 ? void 0 : jobPosition.shift_notes) || ''
    };
  }, [jobPosition === null || jobPosition === void 0 ? void 0 : jobPosition.days_required_per_week, jobPosition === null || jobPosition === void 0 ? void 0 : jobPosition.days_required_per_week_number, jobPosition === null || jobPosition === void 0 ? void 0 : (_jobPosition$job_type2 = jobPosition.job_type_var) === null || _jobPosition$job_type2 === void 0 ? void 0 : _jobPosition$job_type2.label, jobPosition === null || jobPosition === void 0 ? void 0 : jobPosition.shift_notes, jobPosition === null || jobPosition === void 0 ? void 0 : jobPosition.shifts]);
  var isEmptyEl = useMemo(function () {
    var _jobPosition$days_req, _jobPosition$shifts;

    return Boolean(!(jobPosition !== null && jobPosition !== void 0 && (_jobPosition$days_req = jobPosition.days_required_per_week) !== null && _jobPosition$days_req !== void 0 && _jobPosition$days_req.length) && !(jobPosition !== null && jobPosition !== void 0 && jobPosition.days_required_per_week_number) && !(jobPosition !== null && jobPosition !== void 0 && (_jobPosition$shifts = jobPosition.shifts) !== null && _jobPosition$shifts !== void 0 && _jobPosition$shifts.length));
  }, [jobPosition === null || jobPosition === void 0 ? void 0 : (_jobPosition$days_req2 = jobPosition.days_required_per_week) === null || _jobPosition$days_req2 === void 0 ? void 0 : _jobPosition$days_req2.length, jobPosition === null || jobPosition === void 0 ? void 0 : jobPosition.days_required_per_week_number, jobPosition === null || jobPosition === void 0 ? void 0 : (_jobPosition$shifts2 = jobPosition.shifts) === null || _jobPosition$shifts2 === void 0 ? void 0 : _jobPosition$shifts2.length]);
  if (isEmptyEl) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(JobShifts, _objectSpread({}, jobShiftsArgs)), /*#__PURE__*/_jsx(Divider, {})]
  });
}; // Località


var LocationPreview = function LocationPreview(_ref8) {
  var _restaurant$pictures;

  var jobPosition = _ref8.jobPosition;
  var restaurant = jobPosition === null || jobPosition === void 0 ? void 0 : jobPosition.restaurant;
  var mapProps = useMemo(function () {
    return {
      showRestaurant: (jobPosition === null || jobPosition === void 0 ? void 0 : jobPosition.show_restaurant_details) || false,
      lat: (restaurant === null || restaurant === void 0 ? void 0 : restaurant.address_lat) || 0,
      lon: (restaurant === null || restaurant === void 0 ? void 0 : restaurant.address_lon) || 0,
      approximateLat: (restaurant === null || restaurant === void 0 ? void 0 : restaurant.approximate_lat) || 0,
      approximateLon: (restaurant === null || restaurant === void 0 ? void 0 : restaurant.approximate_lon) || 0
    };
  }, [jobPosition === null || jobPosition === void 0 ? void 0 : jobPosition.show_restaurant_details, restaurant === null || restaurant === void 0 ? void 0 : restaurant.address_lat, restaurant === null || restaurant === void 0 ? void 0 : restaurant.address_lon, restaurant === null || restaurant === void 0 ? void 0 : restaurant.approximate_lat, restaurant === null || restaurant === void 0 ? void 0 : restaurant.approximate_lon]);
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsxs(_StyledDiv, {
      children: [/*#__PURE__*/_jsx(Title, {
        content: "Dove si trova",
        icon: "MapIcon",
        wrapperStyle: {
          "marginBottom": "1rem"
        },
        variant: "h4-large",
        fontWeight: "semibold",
        textColor: "black"
      }), /*#__PURE__*/_jsx(MapComponent, _objectSpread({}, mapProps)), (restaurant === null || restaurant === void 0 ? void 0 : restaurant.location_description) && /*#__PURE__*/_jsx(Paragraph, {
        content: restaurant.location_description
      })]
    }), restaurant !== null && restaurant !== void 0 && (_restaurant$pictures = restaurant.pictures) !== null && _restaurant$pictures !== void 0 && _restaurant$pictures.length && mapProps.showRestaurant ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Title, {
        textColor: "black",
        variant: "h6-large",
        fontWeight: "semibold",
        content: "Presentazione del locale"
      }), /*#__PURE__*/_jsx(Paragraph, {
        content: restaurant.brief_description
      }), /*#__PURE__*/_jsx(ImageCarousel, {
        restaurantPictures: restaurant.pictures.map(function (v) {
          return v.url;
        })
      })]
    }) : null]
  });
}; // Layout Components
// Replica il layout della worker-app: flex-row-reverse mette la card a destra su desktop


var PageContentWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-preview__PageContentWrapper",
  componentId: "sc-kt7akk-0"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "2rem",
  "@media (min-width: 1024px)": {
    "display": "flex",
    "flexDirection": "row-reverse",
    "justifyContent": "center",
    "gap": "2.5rem"
  }
}); // Mobile: mostra la card in cima


var MobileJobInfoCard = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-preview__MobileJobInfoCard",
  componentId: "sc-kt7akk-1"
})({
  "display": "block",
  "@media (min-width: 1024px)": {
    "display": "none"
  }
}); // Desktop: card sticky a destra (appare prima grazie a flex-row-reverse)


var DesktopJobInfoCard = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-preview__DesktopJobInfoCard",
  componentId: "sc-kt7akk-2"
})({
  "display": "none",
  "@media (min-width: 1024px)": {
    "display": "block",
    "width": "24rem",
    "minWidth": "384px"
  }
}); // Colonna principale con i contenuti (appare a sinistra su desktop)


var MainContentColumn = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-preview__MainContentColumn",
  componentId: "sc-kt7akk-3"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "2rem",
  "@media (min-width: 1024px)": {
    "maxWidth": "calc(100vw - 520px)"
  },
  "@media (min-width: 1280px)": {
    "maxWidth": "calc(100vw - 664px)"
  },
  "@media (min-width: 1536px)": {
    "maxWidth": "calc(100vw - 864px)"
  }
});

var Divider = /*#__PURE__*/_styled.hr.withConfig({
  displayName: "job-position-preview__Divider",
  componentId: "sc-kt7akk-4"
})({
  "--tw-text-opacity": "1",
  "color": "rgb(209 213 219 / var(--tw-text-opacity))"
});

export default JobPositionPreview;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-preview___StyledDiv",
  componentId: "sc-kt7akk-5"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0px"
});